<template>
  <div
      :class="[
          'display-flex',
          'card',
          card.disabled ? 'disabled' : '',
          card.isExpired ? 'expired' : '',
          (card.selected || selected) ? 'selected' : '',
      ]"
  >
    <div class="display-flex">
      <div class="title">{{ $anm22.strLang(lang, 'Card', 'Tessera') + ' #' + card.number }}</div>
      <div class="info">{{ card.firstName + ' ' + card.lastName }}</div>
      <div v-if="card.email" class="info">{{ card.email }}</div>
      <div v-if="card.phoneNumber" class="info">{{ card.phoneAreaCode + ' ' + card.phoneNumber }}</div>
      <div class="info">{{ card.balance.toFixed(2) + $anm22.strLang(lang, ' credits', ' crediti') }}</div>
      <div v-if="card.disabled" class="info error">
        {{ $anm22.strLang(lang, 'Card disabled', 'Tessera non abilitata') }}
      </div>
      <div v-else-if="card.isExpired" class="info error">
        {{ $anm22.strLang(lang, 'Card expired', 'Tessera scaduta') }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  props: {
    card: Object,
    selected: {
      type: Boolean,
      default: false,
    },
    timezone: String,
    view: {
      type: String,
      default: 'employee',
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      lang: state => state.lang
    }), 
  }
}
</script>

<style lang="scss" scoped>
.card {
  flex-wrap:nowrap;
  align-items:center;
  justify-content: center;
  cursor: pointer;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  height: 150px;
  width: calc(25% - 10px);
  margin: 5px;
  &.disabled, &.expired {
    opacity: 0.5;
    pointer-events: none;
  }
  &:hover, &.selected {
    box-shadow: 0 0 0 2px #2196f3;
  }
  div {
    flex-direction: column;
    div {
      text-align: center;
      margin: 2px 0;
    }
    .title {
      font-size: 1.8rem;
    }
    .info {
      font-size: 1.6rem;
      color: #999;
      &.error {
        color: #EF5350;
      }
    }
  }
}
@media screen and(max-width: 1169px) {
  .card {
    width: calc(33.333333% - 10px);
  }
}
@media screen and(max-width: 921px) {
  .card {
    width: calc(50% - 10px);
  }
}
@media screen and(max-width: 767px) {
  .card {
    width: calc(100% - 10px);
  }
}
</style>